/* IFramePreviewPanel.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m91wug%7Boverflow-y%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16jlkb7n%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1osq%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1osq%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19itglyw%7Bborder%3Anone%7D");
import { memo, type MemoExoticComponent, type ReactNode, useEffect, useMemo, useState } from 'react';
import AnalyticsWebClient, { originType, tenantType } from '@atlassiansox/analytics-web-client';
import { fg } from '@atlaskit/platform-feature-flags';
import { useThemeObserver } from '@atlaskit/tokens';
import type { AnalyticsAttributes } from '@atlassian/analytics-bridge';
import { PreviewPanel, PreviewPanelBody, PreviewPanelHeader, PreviewPanelTitle } from '@atlassian/preview-panel';
import { usePreviewPanelsActions } from '@atlassian/preview-panels-api';
import { usePreviewPanelsNavigation } from '@atlassian/preview-panels-api/preview-panel-navigation';
import { getAnalyticsEnv } from '../utils';
type Props = {
  analyticsAttributes?: AnalyticsAttributes;
  ari?: string;
  icon: ReactNode;
  iframeUrl: string;
  name: string;
  panelType?: string;
  parentProduct?: string;
  product: string;
  url: string;
};
const styles = {
  iframe: "_19itglyw _1bsb1osq _4t3i1osq",
  body: "_1e0c1txw _16jlkb7n _18m91wug"
};
export const getCloudIdFromAri = (ari?: string): string | undefined => {
  if (!ari || typeof ari !== 'string' || !ari.startsWith('ari:cloud:jira:')) {
    return undefined;
  }
  const parts = ari.split(':');
  if (parts.length !== 5) {
    return undefined;
  }
  const cloudId = parts[3];
  if (!cloudId) {
    return undefined;
  }
  return cloudId;
};
export const IFramePreviewPanel: MemoExoticComponent<({
  url,
  iframeUrl,
  name,
  icon,
  panelType,
  product,
  parentProduct,
  ari,
  analyticsAttributes
}: Props) => JSX.Element> = memo(({
  url,
  iframeUrl,
  name,
  icon,
  panelType,
  product,
  parentProduct,
  ari,
  analyticsAttributes
}: Props): JSX.Element => {
  const {
    close
  } = usePreviewPanelsActions();
  const {
    canNavigateBack,
    navigateBack
  } = usePreviewPanelsNavigation();
  const [analyticsClient, setAnalyticsClient] = useState<AnalyticsWebClient>();
  const cloudId = ari ?? getCloudIdFromAri(ari);
  const {
    colorMode
  } = useThemeObserver();
  useEffect(() => {
    setAnalyticsClient(() => {
      let analyticsClient = new AnalyticsWebClient({
        product,
        env: getAnalyticsEnv(window.location.hostname),
        origin: originType.WEB
      });
      if (cloudId) {
        analyticsClient?.setTenantInfo(tenantType.CLOUD_ID, cloudId);
      }
      return analyticsClient;
    });
  }, [product, cloudId]);

  // Create iframe URL with theme parameter
  const iframeSrc = useMemo(() => {
    if (!iframeUrl || !colorMode) {
      return iframeUrl;
    }
    const url = new URL(iframeUrl, window.location.origin);
    url.searchParams.set('themeMode', colorMode);
    return url.toString();
  }, [iframeUrl, colorMode]);
  return <PreviewPanel>
				<PreviewPanelHeader onClose={close} onNavigateBack={canNavigateBack && fg('jivtech-1920-back-navigation-gpp') ? navigateBack : undefined} url={url} parentProduct={parentProduct} panelType={panelType} analyticsClient={analyticsClient}>
					<PreviewPanelTitle title={name} icon={icon} />
				</PreviewPanelHeader>
				<PreviewPanelBody styles={styles.body} parentProduct={parentProduct} panelType={panelType} analyticsClient={analyticsClient} {...fg('add_capacity_tab_to_the_board_horizontal_nav') ? {
      analyticsAttributes
    } : {}}>
					<iframe src={iframeSrc} title={name} className={ax([styles.iframe])} />
				</PreviewPanelBody>
			</PreviewPanel>;
});